module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "title": "Contents"
    }
  }, [_c('h2', {
    staticClass: "fmt"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_c('span', {
    staticClass: "cb"
  }, [_vm._v("Contents")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Foreword#rtoc1",
      "id": "toc1"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Preface#rtoc2",
      "id": "toc2"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Acknowledgments#rtoc3",
      "id": "toc3"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Authors_Note#rtoc4",
      "id": "toc4"
    }
  }, [_vm._v("Authors’ Note")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1t"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Intro#rtoc5",
      "id": "toc5"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#rtoc6",
      "id": "toc6"
    }
  }, [_vm._v("Part One: This Is What We Had")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter03#rtoc7",
      "id": "toc7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two: Creating a New National Network")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter05#rtoc8",
      "id": "toc8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three: Where Do We Go from Here?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter07#rtoc9",
      "id": "toc9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Four: The Road to the Future")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Epilogo#rtoc10",
      "id": "toc10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Appendix1#rtoc11",
      "id": "toc11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 1: Tracking Amtrak")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Appendix2#rtoc12",
      "id": "toc12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 2: Amtrak Presidents and US Secretaries of Transportation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Bibliography#rtoc13",
      "id": "toc13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Index#rtoc14",
      "id": "toc14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0156f4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Contents.vue
// module id = 78
// module chunks = 0